import React, { useCallback, useEffect, useState } from 'react'
import { IResponsePost } from '../../../../Interfaces/base/IResponse';
import { useBoolean } from "@fluentui/react-hooks";
import { IActualizarActividad } from '../../../../Interfaces/IPERC/IActividad';
import ActividadService from '../../../../services/Iperc/ActividadService';
import { DefaultButton, FontIcon, Panel, PanelType, PrimaryButton, TextField } from '@fluentui/react';
import { PanelHeader } from '../../../../components/Panel/PanelHeader';
import { MensajeBar } from '../../../../components/generic/ManejoResponseMessage/MessageBar';
import IdicadorProgress from '../../../../components/generic/IndicadorProgress';

export const PanelActualizarActividad = (props: any) => {

    const [response, setResponse] = useState<IResponsePost>(null!);
    const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
        useBoolean(false);

    const [actividad, setActividad] =
        useState<IActualizarActividad>({
            actividadId: "",
            nombre: ""
        });

    const [newNombre, setNewNombre] = useState("");

    const [disableBtn, setDisableBtn] = useState(true);

    const onChangeTextField = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string,
        actividadId?: string
    ) => {
        if (event !== undefined) {
            if (newValue !== undefined) {
                if (actividadId) {
                    if (actividad.nombre != newValue) {
                        setDisableBtn(false)
                    }
                    else {
                        setDisableBtn(true)
                    }
                    setNewNombre(newValue)
                }
            }
        }
    };

    const actualizarActividad = () => {
        ocultarMensaje();
        onEnviar();
        const objActualizarActividad: IActualizarActividad = { ...actividad }
        // objActualizarActividad.actividadId = "newNombre"
        objActualizarActividad.nombre = newNombre
        ActividadService.putActualizarNombreActividad(objActualizarActividad)
            .then((res) => {
                if (res.status === 200) {
                    setResponse({
                        codigoMensaje: 1,
                        mensaje: "Actualización realizada",
                    });
                    props.onDismiss();
                    props.onRefreshTable();
                    onCancelar();

                }
                else {
                    setResponse({
                        codigoMensaje: 3,
                        mensaje: "Actualización no realizada",
                    });
                }
                onCancelar();
            })
            .catch((err) => {
                setResponse({
                    codigoMensaje: 3,
                    mensaje: "Error al realizar la actualización",
                });
                onCancelar();
            });
    };

    const ocultarMensaje = () => {
        setResponse(null!);
    };


    const onRenderFooterPanel = useCallback(
        () => (
            <>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        justifyItems: "center",
                        height: "5%",
                        padding: "2opx",
                        margin: "20px",
                    }}
                >
                    <div style={{ display: "flex" }}>
                        <PrimaryButton disabled={disableBtn} onClick={() => actualizarActividad()} text="Guardar" />
                    </div>
                    <div style={{ display: "flex" }}>
                        <DefaultButton
                            onClick={() => {
                                props.onDismiss();
                            }}
                            text={"Salir"}
                        />
                    </div>
                </div>
            </>
        ),
        [props.onDismiss, actualizarActividad, disableBtn]
    );
    const onRenderHeaderPanel = useCallback(
        () => (
            <>
                <PanelHeader
                    key={"editar"}
                    nameIconHeader="Edit"
                    subTextHeader="Editar el Nombre de la Actividad"
                    textHeader="Actividad"
                />
            </>
        ),
        []
    );



    useEffect(() => {
        if (props.isOpen) {
            setActividad(props.modelActualizarActividad);
            setNewNombre(props.modelActualizarActividad?.nombre || "");
            setDisableBtn(true);
        }
    }, [props.isOpen, props.modelActualizarActividad]);

    useEffect(() => {
        if (!props.isOpen) {
            ocultarMensaje();
        }
    }, [props.isOpen]);


    return (
        <>

            <Panel
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
                isFooterAtBottom={true}
                onRenderHeader={onRenderHeaderPanel}
                onRenderFooter={onRenderFooterPanel}
                closeButtonAriaLabel="Close"
                type={PanelType.smallFixedFar}
                isLightDismiss
            >
                {/* <pre>{JSON.stringify("--------Exsiste Actividad---", null, 2)}</pre>
                <pre>{JSON.stringify(props.modelActualizarActividad, null, 2)}</pre>
                <pre>{JSON.stringify(newNombre, null, 2)}</pre> */}
                <MensajeBar
                    response={response}
                    ocultar={() => {
                        ocultarMensaje();
                    }}
                />

                {isSend === true ? (
                    <>
                        <IdicadorProgress
                            isSend={isSend}
                            subText="Espere un momento..."
                        />
                    </>
                ) : (
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-lg12">
                            <br />
                            <TextField
                                label="Nombre de Actividad:"
                                value={newNombre}
                                onChange={(e, value) =>
                                    onChangeTextField(e, value, props.modelActualizarActividad?.actividadId)
                                }
                                onRenderPrefix={(arg) => (
                                    <FontIcon
                                        iconName="Rename"
                                    //style={{ color: COLORES.Bases.primary }}
                                    />
                                )}
                                placeholder="Nombre de Actividad *"
                            />
                        </div>
                    </div>
                )}
            </Panel>
        </>
    )
}
